module.exports = __webpack_public_path__ + "fonts/DINNextLTPro-Bold.aca69b5c.woff2";